<template>
    <div class="fs-3">
        <!-- CTA -->
        <el-dropdown class="absolute top-right-3">
            <i class="icon-burger p-2"></i>

            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(action, index) in data.actions" :key="index" 
                    :class="!hasAccess(action.permission, permissions) ? 'link-disabled' : ''"
                    :disabled="!hasAccess(action.permission, permissions)">
                    
                    <!-- VUE JS -->
                    <a  v-if="action.type == 'vuejs'" 
                        @click="!hasAccess(action.permission, permissions) ? null : emitCall(action.value, data, !hasAccess(action.permission, permissions))" 
                        :class="!hasAccess(action.permission, permissions) ? 'link-disabled' : ''">
                        {{action.label}}
                    </a>

                     <!-- HREF -->
                    <a  v-else 
                        :href="!hasAccess(action.permission, permissions) ? null : action.value" 
                        :class="!hasAccess(action.permission, permissions) ? 'link-disabled' : ''">
                        {{action.label}}
                    </a>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>

        <!-- CONTENT -->
        <h4 class="mt-0">{{ data.name }}</h4>
        <ul class="m-0">
            <li class="mb-1">{{ data.part1 }}</li>
            <li class="mb-1" v-if="data.part2 != ''">{{ data.part2 }}</li>
            <li class="mb-1" v-if="data.part2 != ''">{{ data.part3 }}</li>
            <li class="mb-1" v-if="data.part2 != ''">{{ data.part4 }}</li>
            <li class="mb-1">{{ data.zip }} {{ data.town }}</li>
            <li>{{ data.country }}</li>
        </ul>
    </div>
</template>
<script>
    import { hasAccess } from './../helpers'

    export default{
        props: {
            data : {
                type : Object,
                required : true
            },
            permissions : {
                type : Object,
                required : true
            }
        },

        methods:{
            hasAccess,
            emitCall(method, item, disabled) {
                item.disabled = disabled
                item.params = {
                    linkedtype : this.$store.getters.linkedtype,
                    linkedid : this.$store.getters.linkedid
                }
                this.$emit("emit-call", method, item)
            }
        }
    }
</script>
